module.exports = __webpack_public_path__ + "static/media/errorToast.e1142d02.svg";